import React from "react";
import Product from "../Product/Product";

function NewProduct({
  account_slug,
  project_id,
  projectStatus,
  account_id,
  products,
  services,
  productCreated,
  setProductCreated,
  productId,
  authorizationCode,
  productPvs,
}) {
  return (
    <Product
      account_slug={account_slug}
      project_id={project_id}
      account_id={account_id}
      projectStatus={projectStatus}
      products={products}
      services={services}
      productCreated={productCreated}
      setProductCreated={setProductCreated}
      productId={productId}
      authorizationCode={authorizationCode}
      productPvs={productPvs}
    />
  );
}

export default NewProduct;
